export default Object.freeze({
  EXPIRED_ACTIVATION_TOKEN: 'expired-activation-token',
});
